var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17a1 1 0 110 2 1 1 0 010-2zM21.25 17.25a.75.75 0 010 1.5H7.75a.75.75 0 010-1.5h13.5zM3 11a1 1 0 110 2 1 1 0 010-2zM21.25 11.25a.75.75 0 010 1.5H7.75a.75.75 0 010-1.5h13.5zM3 5a1 1 0 110 2 1 1 0 010-2zM21.25 5.25a.75.75 0 010 1.5H7.75a.75.75 0 010-1.5h13.5z",
    fill: "currentColor"
  })));
}
SvgList.displayName = 'List';
export default SvgList;